/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';
import { SoilType } from 'src/app/shared/models';

export enum SoilTypeActionTypes {
  LoadSoilTypesRequest = '[SoilType] Load cultivation targets request',
  LoadSoilTypesSuccess = '[SoilType] Load cultivation targets success',
  LoadSoilTypesFailed = '[SoilType] Load cultivation targets failed',
}

export class LoadSoilTypesRequest implements Action {
  readonly type = SoilTypeActionTypes.LoadSoilTypesRequest;
}

export class LoadSoilTypesSuccess implements Action {
  readonly type = SoilTypeActionTypes.LoadSoilTypesSuccess;

  constructor(public readonly soilTypes: SoilType[]) {}
}

export class LoadSoilTypesFailed implements Action {
  readonly type = SoilTypeActionTypes.LoadSoilTypesFailed;

  constructor(public readonly message: string) {}
}

export type SoilTypeActions = LoadSoilTypesRequest | LoadSoilTypesSuccess | LoadSoilTypesFailed;
